const my_profile = {
  viewMyClubSeacretProfile: "Visualizza il profilo di My ClubSecret", // translated
  unverifiedEmail: "E-mail non verificata", // translated
  verifiedEmail: "E-mail verificata", // translated
  viewMoreDetails: "Visualizza ulteriori dettagli", // translated
  createdFrom: "Creato da", // translated
  createdTo: "Creato fino a", // translated
  selectStatus: "Seleziona stato...", // translated
  searchByTitle: "Cerca per titolo...", // translated
};

export default my_profile;
